import React from 'react'
import {useNavigate} from "react-router-dom"

const Prices = ({projectRef}) => {

    const navigate = useNavigate()

    const Navagit = ()=>{
        navigate("/signup-email")
    }

  return (
    <div ref={projectRef} className='proces xl:py-[140px] xl:h-[900px] lg:h-[700px] h-auto lg:py-[100px] py-[50px] pb-[200px]'>
        <div className="container">
            <div className='flex items-center lg:flex-row flex-col justify-between  gap-5'>
                <div className='flex-[2]'>
                    <h2 className='md:text-[64px] md:pr-20 text-[32px] leading-[37px] mb-7 md:leading-[75px] font-bold'>Enamórate de nuestro servicio</h2>
                    <p className='md:text-[24px] md:leading-[28px] font-normal text-[14px] leading-[16px]'>La mejor manera de describir nuestro servicio es sin complicaciones y a un excelente precio</p>
                </div>
                <div className='flex-[3]'>
                    <div className='flex items-center gap-9 sm:flex-row flex-col'>
                    <div onClick={()=>Navagit()} className='p-[32px] cursor-pointer w-full md:h-[320px] h-[199px] flex flex-col items-center gap-[10px] justify-center bg-white shadow-lg rounded-md hover:bg-[#4285F4] hover:text-white'>
                        <p className='text-center xl:text-[24px] text-[14px] md:leading-[37px] leading-[16px]'>Análisis y regularización fiscal</p>
                        <h2 className='md:text-[64px] md:leading-[75px] text-[32px] leading-[37px] font-semibold'>$1000</h2>
                        <p className='text-center xl:text-[24px] text-[14px] md:leading-[37px] leading-[16px]'>Por año no declarado</p>
                    </div>
                    <div onClick={()=>Navagit()} className='p-[32px] cursor-pointer w-full md:h-[320px] h-[199px]  flex flex-col items-center gap-[10px] justify-center bg-white shadow-lg rounded-md hover:bg-[#4285F4] hover:text-white'>
                        <p className='text-center xl:text-[24px] text-[14px] md:leading-[37px] leading-[16px]'>Tu contabilidad transparente, fácil y en la palma de tu mano</p>
                        <h2 className='md:text-[64px] md:leading-[75px] text-[32px] leading-[37px] font-semibold'>$300 <span className='text-[14px] font-normal'>/Mes</span></h2>
                    </div>
                    </div>
                    <div className='mt-6'>
                        <button className='py-2 px-4 bg-[#4285F4] rounded-lg text-white md:text-[24px] text-[14px] font-normal'>Regístrate y Descarga la app</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Prices